export default __webpack_public_path__ + "static/media/TCD.f5fdef7d.png";